import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemExportRoute: InvariantJiraRoute = {
	name: 'global-settings-system-export',
	path: '/secure/admin/CloudExport.jspa',
};
